
import { mapGetters, mapActions } from 'vuex'
import modals from '~/services/modals'
import MenuIcon from '~/assets/menu.svg'
import EBOIcon from '~/assets/EBO.svg'

export default {
  name: 'MenuBar',
  components: { MenuIcon, EBOIcon },
  props: {
    logo: { type: Boolean, default: true },
    showDashLink: { type: Boolean, default: true },
  },
  data() {
    return {
      showMenuOverlay: false,
    }
  },
  head() {
    return {
      bodyAttrs: {
        class: this.showMenuOverlay ? 'menu-open' : '',
      },
    }
  },
  computed: {
    ...mapGetters(['walletAddress', 'synced']),
  },
  methods: {
    ...mapActions(['initWallet']),
    openMenu() {
      this.showMenuOverlay = true
      this.$store.commit('setSyncOverlay', false)
    },
    openWallet() {
      modals.wallet()
    },
  },
}
